<template>
  <div class="profile">
		<viewprofile :profileid='profileid' v-on:editprofile="handleEdit" v-if="!isEdditing"/>
		<editprofile v-on:editprofile="isEdditing = false" v-else/>
	</div>
</template>

<script>
import viewprofile from "@/components/profile/ViewProfile.vue";
import editprofile from "@/components/profile/EditProfile.vue";
export default {
	components: {
		viewprofile,
		editprofile
	},
	data () {
		return {
			isEdditing: false
		}
	},
	props: {
		profileid: Number
	},
	methods: {
		handleEdit() {
			if (this.profileid) {
				this.isEdditing = true;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
/* .profile {
	height: calc(100vh - 195px);
} */
</style>